import store from '../../../core/store';

export const createSubstage = (formData) => {
  return store.dispatch({
    action: 'table.substages/CREATE_SUBSTAGE',
    method: 'POST',
    endpoint: '/stages/' + formData.stage_id + '/substages',
    data: formData,
  });
};

export const readSubstage = (stage_id) => {
  return store.dispatch({
    action: 'table.substages/READ_SUBSTAGE',
    method: 'GET',
    endpoint: '/substages/' + stage_id,
  });
};

export const updateSubstage = (substage_id, formData) => {
  return store.dispatch({
    action: 'table.substages/UPDATE_SUBSTAGE',
    method: 'PUT',
    endpoint: '/substages/' + substage_id,
    data: formData,
  });
};

export const deleteSubstage = (stage_id, substage_id) => {
  return store.dispatch({
    action: 'table.substages/DELETE_SUBSTAGE',
    method: 'DELETE',
    endpoint: '/substages/' + substage_id,
  });
};

export const listPossibleStages = (project_id) => {
  return store.dispatch({
    action: 'table.substages/LIST_POSSIBLE_STAGES',
    method: 'GET',
    endpoint: '/projects/' + project_id + '/substages/possible_stages',
  });
};

export const updateSubstageOrder = (stageId, substages) => {
  return store.dispatch({
    action: 'table.substages/UPDATE_SUBSTAGE_ORDER',
    method: 'PUT',
    endpoint: `/stages/${stageId}/substages/reorder`,
    data: {
      substages: substages,
    },
  });
};
